function getSearchString(searchText, includePrerelease, skip, top) {
  searchText = searchText.toLowerCase().trim();
  if (!skip) skip = 0;
  if (!top) top = 15;

  let filter = "IsLatestVersion";
  if (includePrerelease) filter = "IsAbsoluteLatestVersion";

  return `Search()?$filter=${filter}&searchTerm='${searchText}'&targetFramework=''&includePrerelease=${includePrerelease}&$skip=${skip}&$top=${top}&semVerLevel=2.0.0&$orderby=DownloadCount%20desc`;
}

function getLatestPackagesString(top, includePrerelease) {
  if (!top) top = 10;

  let filter = "IsLatestVersion";
  if (includePrerelease) filter = "IsAbsoluteLatestVersion";

  return `Packages?$top=${top}&$filter=${filter}&includePrerelease=${includePrerelease}&$orderby=DownloadCount%20desc`;
}

export function getPackageSearchString(name, top, skip) {
  return `Packages?$filter=Id%20eq%20%27${name}%27&$orderby=Published%20desc&$top=${top}&$skip=${skip}`;
}

export function getPackageByIdAndVersion(id, version) {
  return `https://community.chocolatey.org/api/v2/Packages(Id='${id}',Version='${version}')`;
}

const STRICT_FILTER_BASE_STRING = `Packages?$filter=`;

export default {
  getSearchString,
  getLatestPackagesString,
  getPackageSearchString,
  getPackageByIdAndVersion,
  STRICT_FILTER_BASE_STRING,
};
